import {faker}  from "@faker-js/faker";
import { getAccounts } from "../helpers/get-accounts";
import defaultValuesOld from "../scenarios/edu-scenarios";

var regionCodes = [
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2",
  "ap-south-1",
];

var tags = [
  "HR-Prod-BackEnd-Server2",
  "HR-Prod-DB-Server1",
  "Sales-FrontEnd-Test-Server1",
  "Sales-FrontEnd-Prod-Server1",
  "Sales-FrontEnd-Prod-Server2",
];

var os = defaultValuesOld().os;
var patchPolicies = defaultValuesOld().patchPolicies;

export const allServerGroupInstances = async (group) => {
  let instances = [];
  let accounts = await getAccounts();
  for (var i = 0; i < group.Instances; i++) {
    instances.push({
      InstanceId: "i-" + faker.random.alphaNumeric(15),
      InstanceName: faker.helpers.arrayElement(tags),
      AccountNumber: faker.helpers.arrayElement(accounts),
      RegionCode: faker.helpers.arrayElement(regionCodes),
      BaselineName: "TestPatchGroup",
      OperatingSystem: faker.helpers.arrayElement(os),
      Operation: "Scan",
      OperationStartTime: faker.date.past(),
      OperationEndTime: faker.date.past(),
      FailedCount: faker.number.int({ max: 100 }),
      InstalledCount: faker.number.int({ max: 100 }),
      InstalledOtherCount: faker.number.int({ max: 100 }),
      NotApplicableCount: faker.number.int({ max: 100 }),
      MissingCount: faker.number.int({ max: 100 }),
      PatchGroup: faker.helpers.arrayElement(patchPolicies).policyName,
      InstalledRejectedCount: faker.number.int({ min: 2, max: 15 }),
    });
  }
  return {
    Data: instances,
    Name: group.Name,
    Description: group.Description,
  };
};
